var Const = /** @class */ (function () {
    function Const() {
    }
    Const.RUN_LOYALITY_SUBSCRIP_VERIFY = '/RUN_LOYALITY_SUBSCRIP_VERIFY';
    Const.RUN_GET_COUNTRIES_LIST = '/RUN_GET_COUNTRIES_LIST';
    Const.RUN_GET_CITIES_LIST = '/RUN_GET_CITIES_LIST';
    Const.RUN_GET_USER_PROFILE = '/RUN_GET_USER_PROFILE';
    Const.GET_USER_PROFILE = '/GET_USER_PROFILE';
    Const.SET_USER_PROFILE = '/SET_USER_PROFILE';
    Const.GET_DASHBOARD_DATA = '/GET_DASHBOARD_DATA';
    Const.SET_DASHBOARD_DATA = '/SET_DASHBOARD_DATA';
    Const.SET_COUNTRIES_LIST = '/SET_COUNTRIES_LIST';
    Const.GET_COUNTRIES_LIST = '/GET_COUNTRIES_LIST';
    Const.SET_CITIES_LIST = '/SET_CITIES_LIST';
    Const.GET_CITIES_LIST = '/GET_CITIES_LIST';
    //dashboard
    Const.RUN_API_DASHBOARD_DATA = '/RUN_API_DASHBOARD_DATA';
    Const.RUN_GET_DASHBOARD_OTHER_DATA = '/RUN_GET_DASHBOARD_OTHER_DATA';
    Const.RUN_GET_TOTAL_CLIENT = '/RUN_GET_TOTAL_CLIENT';
    Const.RUN_GET_TOTAL_SUBIB = '/RUN_GET_TOTAL_SUBIB';
    Const.RUN_GET_DASHBOARD_CHART_DATA = '/RUN_GET_DASHBOARD_CHART_DATA';
    Const.SET_DASHBOARD_CHART_DATA = '/SET_DASHBOARD_CHART_DATA';
    Const.GET_DASHBOARD_CHART_DATA = '/GET_DASHBOARD_CHART_DATA';
    //ib
    Const.RUN_GET_IB_LIST = '/RUN_GET_IB_LIST';
    Const.RUN_GET_IB_DETAIL = '/RUN_GET_IB_DETAIL';
    Const.SET_IB_LIST = '/SET_IB_LIST';
    Const.GET_IB_LIST = '/GET_IB_LIST';
    Const.SET_IB_DETAIL = '/SET_IB_DETAIL';
    Const.GET_IB_DETAIL = '/GET_IB_DETAIL';
    //client
    Const.RUN_GET_ACCOUNT_DETAIL = '/RUN_GET_ACCOUNT_DETAIL';
    Const.RUN_GET_USER_LIST = '/RUN_GET_USER_LIST';
    //public static RUN_WITHDRAWAL_METHODS:string  = '/RUN_WITHDRAWAL_METHODS'
    Const.RUN_GET_USER_VIEW = '/RUN_GET_USER_VIEW';
    Const.RUN_USER_COUNT = '/RUN_USER_COUNT';
    // user sub ib list
    Const.RUN_GET_USER_SUBIB_LIST = '/RUN_GET_USER_SUBIB_LIST';
    Const.GET_USER_SUBIB_LIST = '/GET_USER_SUBIB_LIST';
    Const.SET_USER_SUBIB_LIST = '/SET_USER_SUBIB_LIST';
    Const.SET_USER_LIST = '/SET_USER_LIST';
    Const.GET_USER_LIST = '/GET_USER_LIST';
    Const.SET_USER_VIEW = '/SET_USER_VIEW';
    Const.GET_USER_VIEW = '/GET_USER_VIEW';
    Const.SET_USER_COUNT = '/SET_USER_COUNT';
    Const.GET_USER_COUNT = '/GET_USER_COUNT';
    //deposit
    Const.RUN_GET_DEPOSIT_LIST = '/RUN_GET_DEPOSIT_LIST';
    Const.RUN_GET_DEPOSIT_VIEW = '/RUN_GET_DEPOSIT_VIEW';
    Const.SET_DEPOSIT_LIST = '/SET_DEPOSIT_LIST';
    Const.GET_DEPOSIT_LIST = '/GET_DEPOSIT_LIST';
    Const.SET_DEPOSIT_VIEW = '/SET_DEPOSIT_VIEW';
    Const.GET_DEPOSIT_VIEW = '/GET_DEPOSIT_VIEW';
    //bonus
    Const.RUN_GET_BONUS_LIST = '/RUN_GET_BONUS_LIST';
    Const.RUN_GET_BONUS_VIEW = '/RUN_GET_BONUS_VIEW';
    Const.SET_BONUS_LIST = '/SET_BONUS_LIST';
    Const.GET_BONUS_LIST = '/GET_BONUS_LIST';
    Const.SET_BONUS_VIEW = '/SET_BONUS_VIEW';
    Const.GET_BONUS_VIEW = '/GET_BONUS_VIEW';
    Const.RUN_GET_USER_REGISTERATION_STEP_DATA = '/RUN_GET_USER_REGISTERATION_STEP_DATA';
    //withdrawal
    Const.RUN_COMMISSION_REQUEST = '/RUN_COMMISSION_REQUEST';
    Const.RUN_GET_WITHDRAWAL_COMMISSION_LIST = '/RUN_GET_WITHDRAWAL_COMMISSION_LIST';
    Const.RUN_GET_WITHDRAWAL_LIST = '/RUN_GET_WITHDRAWAL_LIST';
    Const.RUN_GET_WITHDRAWAL_VIEW = '/RUN_GET_WITHDRAWAL_VIEW';
    Const.RUN_GET_AFFILIATE_EARNINGS = '/RUN_GET_AFFILIATE_EARNINGS';
    Const.SET_AFFILIATE_EARNINGS = '/SET_AFFILIATE_EARNINGS';
    Const.GET_AFFILIATE_EARNINGS = '/GET_AFFILIATE_EARNINGS';
    Const.RUN_WITHDRAWAL_REQUEST_OTP = '/RUN_WITHDRAWAL_REQUEST_OTP';
    Const.RUN_WITHDRAWAL_CHECK_OTP = '/RUN_WITHDRAWAL_CHECK_OTP';
    Const.RUN_RESEND_EMAIL_LINK = '/RUN_RESEND_EMAIL_LINK';
    Const.RUN_GET_WITHDRAWAL_METHODS = '/RUN_GET_WITHDRAWAL_METHODS';
    Const.RUN_GET_WITHDRAWAL_DESC = '/RUN_GET_WITHDRAWAL_DESC';
    Const.SET_WITHDRAWAL_LIST = '/SET_WITHDRAWAL_LIST';
    Const.GET_WITHDRAWAL_LIST = '/GET_WITHDRAWAL_LIST';
    Const.SET_WITHDRAWAL_COMMISSION_LIST = '/SET_WITHDRAWAL_COMMISSION_LIST';
    Const.GET_WITHDRAWAL_COMMISSION_LIST = '/GET_WITHDRAWAL_COMMISSION_LIST';
    Const.SET_WITHDRAWAL_VIEW = '/SET_WITHDRAWAL_VIEW';
    Const.GET_WITHDRAWAL_VIEW = '/GET_WITHDRAWAL_VIEW';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE = '/SET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE = '/GET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/GET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE_DEP = '/SET_WITHDRAWAL_METHOD_RESPONSE_DEP';
    Const.GET_WITHDRAWAL_METHOD = '/GET_WITHDRAWAL_METHOD';
    //trading
    Const.RUN_GET_TRADING_LIST = '/RUN_GET_TRADING_LIST';
    Const.RUN_GET_IB_TRADING_LIST = '/RUN_GET_IB_TRADING_LIST';
    Const.RUN_GET_TRADING_VIEW = '/RUN_GET_TRADING_VIEW';
    Const.RUN_GET_TRADING_ACCOUNT_DETAIL = '/RUN_GET_TRADING_ACCOUNT_DETAIL';
    Const.SET_TRADING_ACCOUNT_DETAIL = '/SET_TRADING_ACCOUNT_DETAIL';
    Const.GET_TRADING_ACCOUNT_DETAIL = '/GET_TRADING_ACCOUNT_DETAIL';
    Const.SET_TRADING_LIST = '/SET_TRADING_LIST';
    Const.GET_TRADING_LIST = '/GET_TRADING_LIST';
    Const.SET_IB_TRADING_LIST = '/SET_IB_TRADING_LIST';
    Const.GET_IB_TRADING_LIST = '/GET_IB_TRADING_LIST';
    Const.SET_TRADING_VIEW = '/SET_TRADING_VIEW';
    Const.GET_TRADING_VIEW = '/GET_TRADING_VIEW';
    //support
    Const.RUN_GET_TICKET_LIST = '/RUN_GET_TICKET_LIST';
    Const.RUN_GET_TICKET_DETAIL = '/RUN_GET_TICKET_DETAIL';
    Const.RUN_TICKET_REQUEST_OTP = '/RUN_TICKET_REQUEST_OTP';
    Const.RUN_TICKET_CHECK_OTP = '/RUN_TICKET_CHECK_OTP';
    Const.RUN_TICKET_REPLY = '/RUN_TICKET_REPLY';
    Const.RUN_GET_TICKET_REASON_LIST = '/RUN_GET_TICKET_REASON_LIST';
    Const.RUN_TICKET_RESEND_OTP = '/RUN_TICKET_RESEND_OTP';
    Const.SET_TICKET_DATA = '/SET_TICKET_DATA';
    Const.GET_TICKET_DATA = '/GET_TICKET_DATA';
    Const.SET_TICKET_LIST = '/SET_TICKET_LIST';
    Const.GET_TICKET_LIST = '/GET_TICKET_LIST';
    Const.SET_TICKET_VIEW = '/SET_TICKET_VIEW';
    Const.GET_TICKET_VIEW = '/GET_TICKET_VIEW';
    Const.SET_TICKET_REASON_LIST = '/SET_TICKET_REASON_LIST';
    Const.GET_TICKET_REASON_LIST = '/GET_TICKET_REASON_LIST';
    //static
    Const.GET_TICKET_DOCS_LINK = '/GET_TICKET_DOCS_LINK';
    Const.GET_DEPARMENT_LIST = '/GET_DEPARMENT_LIST';
    Const.GET_BONUS_TYPE = '/GET_BONUS_TYPE';
    Const.GET_BONUS_STATUS = '/GET_BONUS_STATUS';
    Const.GET_PRO_USERS = '/GET_PRO_USERS';
    Const.GET_DEMO_LIVE = '/GET_DEMO_LIVE';
    Const.GET_CURRENCY = '/GET_CURRENCY';
    Const.GET_WITHDRAWAL_TYPE = '/GET_WITHDRAWAL_TYPE';
    Const.GET_WITHDRAWAL_METHODS = '/GET_WITHDRAWAL_METHODS';
    Const.GET_WITHDRAWAL_STATUS = '/GET_WITHDRAWAL_STATUS';
    Const.GET_DEPOSIT_METHOD = '/GET_DEPOSIT_METHOD';
    Const.GET_DEPOSIT_STATUS = '/GET_DEPOSIT_STATUS';
    Const.GET_EMP_STATUS = '/GET_EMP_STATUS';
    Const.GET_OCCUPATION = '/GET_OCCUPATION';
    Const.GET_EST_YEARLY_INCOME = '/GET_EST_YEARLY_INCOME';
    Const.GET_EST_NET_WORTH = '/GET_EST_NET_WORTH';
    Const.GET_ACCOUNT_TURNOVER = '/GET_ACCOUNT_TURNOVER';
    Const.GET_GENDER_LIST = '/GET_GENDER_LIST';
    Const.GET_STEP = '/GET_STEP';
    Const.GET_DASHBOARD_LINK1 = '/GET_DASHBOARD_LINK1';
    Const.GET_DASHBOARD_LINK2 = '/GET_DASHBOARD_LINK2';
    Const.RUN_GET_TRADING_ACCOUNT_LIST = '/RUN_GET_TRADING_ACCOUNT_LIST';
    Const.GET_TRADING_ACCOUNT_LIST = '/GET_TRADING_ACCOUNT_LIST';
    Const.SET_TRADING_ACCOUNT_LIST = '/SET_TRADING_ACCOUNT_LIST';
    Const.RUN_GET_USER_COMMISSION = '/RUN_GET_USER_COMMISSION';
    Const.GET_USER_COMMISSION = '/GET_USER_COMMISSION';
    Const.SET_USER_COMMISSION = '/SET_USER_COMMISSION';
    //withdrawal method list
    Const.RUN_WITHDRAWAL_METHOD_LIST = '/RUN_WITHDRAWAL_METHOD_LIST';
    Const.SET_SKRILL_ID = '/SET_SKRILL_ID';
    Const.GET_SKRILL_ID = '/GET_SKRILL_ID';
    Const.SET_NETELLER_ID = '/SET_NETELLER_ID';
    Const.GET_NETELLER_ID = '/GET_NETELLER_ID';
    Const.SET_CRYPTO_ID_LIST = '/SET_CRYPTO_ID_LIST';
    Const.GET_CRYPTO_ID_LIST = '/GET_CRYPTO_ID_LIST';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/provider/candle-history/lib/const.cls.ts
// module id = H1/N
// module chunks = 4